import {createAction, props} from '@ngrx/store';
import {Quote} from '../model/quote';

export const cleanUp = createAction(
    '[Quotes] CleanUp'
);

export const load = createAction(
    '[Quotes] Load'
);

export const loadingSuccess = createAction(
    '[Quotes] Loading success',
    props<{ quotes: Quote[] }>()
);

export const loadingFailure = createAction(
    '[Quote] Loading Failure',
    props<{ error: string }>()
);
